var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconInterfaceSearchSmall = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "outline_art_-_SVG_EXPORT",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m31.41,30l-8.68-8.68c1.41-1.72,2.26-3.93,2.26-6.32,0-5.51-4.49-10-10-10S5,9.49,5,15s4.49,10,10,10c2.4,0,4.6-.85,6.32-2.26l8.68,8.68,1.41-1.41ZM7,15c0-4.41,3.59-8,8-8s8,3.59,8,8-3.59,8-8,8-8-3.59-8-8Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconInterfaceSearchSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-interface-search-small.b5402b4115006a85b0bc65da1e25080e.svg";